export default "__VITE_ASSET__D$xgmqGO__"